const locale = {
  common: {
    loading: "Loading...",
    error: "Error: {{message}}",
    noDataFound: "No data found",
    search: "Search",
    actions: "Actions",
    save: "Save",
    saving: "Saving...",
    update: "Update",
    updating: "Updating...",
    cancel: "Cancel",
    edit: "Edit",
    delete: "Delete",
    create: "Create",
    submit: "Submit",
    close: "Close",
    previous: "Previous",
    next: "Next",
    page: "Page {{current}} of {{total}}",
    confirmation: "Confirmation",
    yes: "Yes",
    no: "No",
    user: "User",
    errorObj: {
      fieldRequired: "This field is required",
      connectionError: "Connection error",
      unknownError: "Unknown error"
    },
    notSpecified: "Not specified",
    refresh: "Refresh",
    copied: "Copied!",
    filter: "Filter",
    generate: "Generate",
    current: "Current",
    undo: "Undo"
  },
  navigation: {
    dashboard: "Dashboard",
    pharmacies: "Pharmacies",
    users: "Users",
    settings: "Settings",
    logout: "Logout",
    profileSettings: "Profile Settings",
    profile: "Profile",
    changePassword: "Change Password",
    categories: "Categories",
    labTests: "Lab Tests",
    dnaSamples: "Upload PDFs",
    testResults: "Test Results",
    tutorials: "Tutorials",
  },
  sidebar: {
    administrator: "Administrator",
    mainNavigation: "Main Navigation",
    version: "somaplus Admin Dashboard v{{version}}",
  },
  dashboard: {
    title: "Dashboard",
    selectDate: "Select Date",
    refreshData: "Refresh Data",
    totalPharmacies: "Total Pharmacies",
    activePharmacies: "Active Pharmacies",
    totalRevenue: "Total Revenue",
    totalUsers: "Total Users",
    lastUpdated: "Last updated",
    totalCancelledBooking: "Cancelled Bookings",
    totalOpenBooking: "Open Bookings",
    totalPerformedTests: "Performed Tests",
    pharmacies: "Pharmacies",
    selectPharmacy: "Select Pharmacy",
    loadingPharmacies: "Loading pharmacies...",
    testsUnderPharmacy: "Tests under {{name}}",
    totalTestsCompleted: "Total Tests Completed",
    staffBookings: "Staff Bookings",
    nonStaffBookings: "Non-Staff Bookings",
    totalCount: "Total Count",
    staffCount: "Staff",
    nonStaffCount: "Non-Staff",
    noTestRecords: "No test records available for this pharmacy",
    testCountsPeriodHint: "Counts reflect finished tests in the selected date range."
  },
  leaderboard: {
    title: "Pharmacy Leaderboard",
    subtitle:
      "See which pharmacies completed the most tests. Pharmacy names are shown for admin overview.",
    thisMonth: "This month",
    lastMonth: "Last month",
    thisWeek: "This week",
    lastWeek: "Last week",
    periodRange: "{{start}} to {{end}}",
    rank: "Rank",
    pharmacy: "Pharmacy",
    tests: "Tests",
    outOfPharmacies: "{{total}} pharmacies ranked",
    testsCompleted: "{{count}} tests completed",
    networkTrends: "Top tests across the network",
    noTrendData: "No network test trends for this period yet.",
    noData: "No leaderboard data for this period yet.",
    expand: "Expand",
    collapse: "Collapse",
    collapsedHint: "Tap to view",
    collapsedEmpty: "No pharmacies ranked for this period yet.",
    loadingSummary: "Loading leaderboard…",
    publicTitle: "Pharmacy Leaderboard",
    publicLoginHint: "Sign in to view the ranking",
    publicLoginError: "Invalid email or password",
    publicLoadError: "Failed to load leaderboard",
  },
  auth: {
    email: "Email",
    password: "Password",
    login: "Login",
  },
  users: {
    title: "Users Management",
    addNew: "Add New User",
    editUser: "Edit User",
    searchPlaceholder: "Search by name or email...",
    serialNumber: "Serial No.",
    fullName: "Full Name",
    email: "Email",
    role: "Role",
    status: "Status",
    statusActive: "Active",
    statusInactive: "Inactive",
    addedOn: "Added On",
    actions: "Actions",
    totalRecords: "Total Records",
    confirmDelete: "Are you sure you want to delete \"{{name}}\"?",
    deleted: "User Deleted!",
    userProfile: "User Profile",
    accountInfo: "Account Information",
    firstName: "First Name",
    lastName: "Last Name",
    emailAddress: "Email Address",
    phoneNumber: "Phone Number",
    userRole: "User Role",
    password: "Password",
    confirmPassword: "Confirm Password",
    passwordsDoNotMatch: "Passwords do not match",
    userCreated: "User created successfully!",
    userUpdated: "User updated successfully!",
    invalidEmail: "Email is invalid",
    searchMinChars: "Type at least 3 characters to search",
    passwordGenerated: "Password generated! Don't forget to copy it."
  },
  pharmacies: {
    title: "Pharmacies Management",
    addNew: "Add New Pharmacy",
    editPharmacy: "Edit Pharmacy",
    searchPlaceholder: "Search by pharmacy name...",
    serialNumber: "Serial No.",
    pharmacyName: "Pharmacy Name",
    owner: "Owner",
    location: "Location",
    status: "Status",
    statusActive: "Active",
    statusInactive: "Inactive",
    addedOn: "Added On",
    actions: "Actions",
    totalRecords: "Total Records",
    confirmDelete: "Are you sure you want to delete \"{{name}}\"?",
    deleted: "Pharmacy Deleted!",
    pharmacyDetails: "Pharmacy Details",
    contactInfo: "Contact Information",
    address: "Address",
    city: "City",
    postalCode: "Postal Code",
    country: "Country",
    phoneNumber: "Phone Number",
    emailAddress: "Email Address",
    taxDetails: "Tax Details",
    vatId: "VAT ID",
    registrationNumber: "Registration Number",
    pharmacyCreated: "Pharmacy created successfully!",
    pharmacyUpdated: "Pharmacy updated successfully!",
    enterPharmacyName: "Enter pharmacy name",
    description: "Description",
    street: "Street",
    houseNumber: "House/Building Number",
    taxId: "Tax ID",
    selectExistingUser: "Select Existing User",
    createNewUser: "Create New User",
    searchUsers: "Search users...",
    noUsersFound: "No users found",
    userDetails: "User Details",
    firstName: "First Name",
    lastName: "Last Name",
    mobile: "Mobile",
    email: "Email",
    password: "Password",
    generatePassword: "Generate Password",
    copyPassword: "Copy Password",
    image: "Pharmacy Image",
    markdownSupport: "Supports markdown formatting for rich text.",
    currentAdmin: "Current Administrator",
    currentAdmins: "Current Administrators",
    searchResults: "Search Results",
    typeMinChars: "Type at least 3 characters to search",
    adminInfo: "New Admin Information",
    pharmacyImage: "Current pharmacy image",
    totalCompletedOrders: "Total Tests Completed",
    totalTestsShort: "Total",
    expandedTestCompleted: "Test Completed Overview",
    staffBookings: "Staff Bookings",
    nonStaffBookings: "Non-Staff Bookings",
    totalCount: "Total Count",
    staffCount: "Staff",
    nonStaffCount: "Non-Staff",
    noTestRecords: "No test records available for this pharmacy",
    testCountsPeriod: "Test counts period",
    testCountsPeriodHint: "Finished tests completed in the selected date range."
  },
  auth: {
    login: "Login",
    logout: "Logout",
    email: "Email",
    password: "Password",
    forgotPassword: "Forgot Password?",
    rememberMe: "Remember Me",
    signIn: "Sign In",
    signUp: "Sign Up",
    resetPassword: "Reset Password",
    newPassword: "New Password",
    confirmPassword: "Confirm Password",
    passwordsDoNotMatch: "Passwords do not match",
    resetPasswordSuccess: "Password reset successful!",
    resetPasswordError: "Error resetting password"
  },
  settings: {
    title: "Settings",
    general: "General Settings",
    account: "Account Settings",
    notifications: "Notifications",
    security: "Security & Privacy",
    appearance: "Appearance",
    language: "Language",
    selectLanguage: "Select Language",
    english: "English",
    german: "German",
    darkMode: "Dark Mode",
    saveChanges: "Save Changes",
    settingsUpdated: "Settings updated successfully!",
    billing: "Billing & Invoices",
    profileSettings: "Profile Settings"
  },
  categories: {
    title: "Categories",
    addNew: "Add New Category",
    editCategory: "Edit Category",
    name: "Name",
    description: "Description",
    image: "Image",
    active: "Active",
    inactive: "Inactive",
    status: "Status",
    confirmDelete: "Are you sure you want to delete \"{{name}}\" category?",
    categoryCreated: "Category added successfully",
    categoryUpdated: "Category updated successfully",
    enterName: "Enter category name"
  },
  labTests: {
    title: "Lab Tests",
    addNew: "Add Lab Test",
    editLabTest: "Edit Lab Test",
    name: "Test Name",
    description: "Description",
    price: "Price",
    duration: "Duration",
    status: "Status",
    actions: "Actions",
    savePackage: "Save Package",
    saveTest: "Save Test",
    next: "Next",
    ageRange: "Age Range",
    deleteConfirmation: "Are you sure you want to delete the test?"
  },
  dnaSamples: {
    title: "Upload PDFs",
    searchPlaceholder: "Search by name, email, phone, sample ID, or ID...",
    totalRecords: "Total Records",
    loading: "Loading...",
    errorLoading: "Error loading DNA submissions: {{error}}",
    retry: "Retry",
    noSubmissionsFound: "No DNA submissions found.",
    noSubmissionsMatching: "No submissions found matching your search.",
    tableHeaders: {
      serialNumber: "#",
      name: "Name",
      email: "Email",
      phone: "Phone",
      sampleId: "Sample ID",
      type: "Type",
      status: "Status",
      resultStatus: "Result Status",
      resultUploaded: "Result Uploaded",
      created: "Created",
      actions: "Actions"
    },
    status: {
      active: "Active",
      inactive: "Inactive",
      available: "Available",
      pending: "Pending"
    },
    actions: {
      viewDetails: "View Details",
      uploadResult: "Upload Result",
      resendEmail: "Resend Email",
      viewResult: "View Result",
      downloadResult: "Download Result"
    },
    modals: {
      detailsTitle: "Upload PDFs",
      uploadResultTitle: "Upload PDFs"
    },
    notifications: {
      emailSentSuccess: "Email sent successfully",
      emailSendFailed: "Failed to send email"
    },
    pagination: {
      previous: "Previous",
      next: "Next",
      page: "Page {{current}} of {{total}}"
    },
    detailsModal: {
      loading: "Loading sample details...",
      errorLoading: "Error loading sample details: {{error}}",
      retry: "Retry",
      noDetailsFound: "No sample details found.",
      personalInformation: "Personal Information",
      sampleInformation: "Sample Information",
      resultInformation: "Result Information",
      timestamps: "Timestamps",
      additionalInformation: "Additional Information",
      fields: {
        firstName: "First Name",
        lastName: "Last Name",
        email: "Email",
        phone: "Phone",
        sampleId: "Sample ID",
        type: "Type",
        status: "Status",
        resultStatus: "Result Status",
        resultUploadedAt: "Result Uploaded At",
        createdAt: "Created At",
        updatedAt: "Updated At"
      },
      actions: {
        close: "Close",
        downloadResult: "Download Result"
      }
    },
    uploadModal: {
      sampleInformation: "Sample Information",
      fileUpload: "File Upload",
      uploadInstructions: "Select a PDF file to upload as the DNA test result",
      selectFile: "Select PDF File",
      noFileSelected: "No file selected",
      fileSelected: "File selected: {{fileName}}",
      fileSize: "File size: {{size}}",
      sendEmailNotification: "Send email notification to patient",
      emailNotificationHelp: "Check this box to automatically send an email notification to the patient when the result is uploaded",
      uploadButton: "Upload Result",
      uploading: "Uploading...",
      cancel: "Cancel",
      deleteFile: "Delete File",
      fields: {
        sampleId: "Sample ID",
        patientName: "Patient Name",
        email: "Email",
        phone: "Phone"
      },
      validation: {
        fileRequired: "PDF file is required",
        onlyPdfAllowed: "Only PDF files are allowed"
      },
      notifications: {
        uploadSuccess: "Result uploaded successfully",
        uploadFailed: "Failed to upload result"
      }
    }
  },
  tutorials: {
    title: "Tutorials",
    addNew: "Add New Tutorial",
    addTutorial: "Add Tutorial",
    editTutorial: "Edit Tutorial",
    viewTutorial: "View Tutorial",
    searchPlaceholder: "Search by title, description, or type...",
    totalRecords: "Total Records",
    loading: "Loading...",
    errorLoading: "Error loading tutorials: {{error}}",
    retry: "Retry",
    noTutorialsFound: "No tutorials found.",
    noTutorialsMatching: "No tutorials found matching your search.",
    tableHeaders: {
      serialNumber: "#",
      title: "Title",
      description: "Description",
      type: "Type",
      content: "Content",
      created: "Created",
      actions: "Actions"
    },
    type: {
      pdf: "PDF",
      video: "VIDEO"
    },
    actions: {
      viewDetails: "View Details",
      editTutorial: "Edit Tutorial",
      deleteTutorial: "Delete Tutorial",
      viewPdf: "View PDF",
      watchVideo: "Watch Video"
    },
    modals: {
      addTitle: "Add New Tutorial",
      editTitle: "Edit Tutorial",
      detailsTitle: "Tutorial Details",
      confirmDelete: "Confirm Delete"
    },
    confirmDelete: "Are you sure you want to delete \"{{title}}\"?",
    notifications: {
      tutorialCreated: "Tutorial created successfully!",
      tutorialUpdated: "Tutorial updated successfully!",
      tutorialDeleted: "Tutorial deleted successfully!"
    },
    pagination: {
      previous: "Previous",
      next: "Next",
      page: "Page {{current}} of {{total}}"
    },
    fields: {
      title: "Title",
      description: "Description",
      type: "Type",
      pdfUrl: "PDF URL",
      videoUrl: "Video URL",
      created: "Created",
      updated: "Updated"
    },
    addModal: {
      title: "Title",
      titleRequired: "Title is required",
      titlePlaceholder: "Enter tutorial title",
      description: "Description (Optional)",
      descriptionPlaceholder: "Enter description",
      type: "Type",
      typeRequired: "Type is required",
      uploadPdfFile: "Upload PDF File",
      uploadPdfRequired: "PDF file is required",
      videoUrl: "Video URL",
      videoUrlRequired: "Video URL is required",
      videoUrlPlaceholder: "Enter video URL",
      fileUpload: {
        clickToUpload: "Click to upload PDF",
        dragAndDrop: "or drag and drop",
        pdfFilesOnly: "PDF files only",
        fileSelected: "File selected: {{fileName}}",
        fileSize: "File size: {{size}} MB",
        removeFile: "Remove file"
      },
      validation: {
        titleRequired: "Title is required",
        typeRequired: "Type is required",
        fileRequired: "PDF file is required",
        videoUrlRequired: "Video URL is required"
      },
      actions: {
        cancel: "Cancel",
        createTutorial: "Create Tutorial",
        creating: "Creating..."
      },
      notifications: {
        tutorialCreated: "Tutorial created successfully",
        tutorialCreateFailed: "Failed to create tutorial"
      }
    },
    detailsModal: {
      loading: "Loading tutorial details...",
      errorLoading: "Error loading tutorial details: {{error}}",
      retry: "Retry",
      noDetailsFound: "No tutorial details found.",
      tutorialInformation: "Tutorial Information",
      content: "Content",
      timestamps: "Timestamps",
      fields: {
        title: "Title",
        description: "Description",
        type: "Type",
        createdAt: "Created At",
        updatedAt: "Updated At"
      },
      contentTypes: {
        pdfDocument: "PDF Document",
        videoContent: "Video Content",
        clickToViewPdf: "Click to view PDF",
        clickToWatchVideo: "Click to watch video"
      },
      actions: {
        close: "Close",
        viewPdf: "View PDF",
        watchVideo: "Watch Video"
      }
    },
    editModal: {
      loading: "Loading tutorial details...",
      title: "Title",
      titleRequired: "Title is required",
      titlePlaceholder: "Enter tutorial title",
      description: "Description (Optional)",
      descriptionPlaceholder: "Enter description",
      type: "Type",
      typeRequired: "Type is required",
      uploadPdfFile: "Upload PDF File",
      uploadPdfRequired: "PDF file is required or existing PDF must be present",
      videoUrl: "Video URL",
      videoUrlRequired: "Video URL is required",
      videoUrlPlaceholder: "Enter video URL",
      currentPdf: "Current PDF: {{fileName}}",
      currentPdfDescription: "Click to view or upload new file to replace",
      fileUpload: {
        clickToUpload: "Click to upload PDF",
        dragAndDrop: "or drag and drop",
        pdfFilesOnly: "PDF files only",
        fileSelected: "File selected: {{fileName}}",
        fileSize: "File size: {{size}} MB",
        removeFile: "Remove file"
      },
      validation: {
        titleRequired: "Title is required",
        typeRequired: "Type is required",
        fileRequired: "PDF file is required or existing PDF must be present",
        videoUrlRequired: "Video URL is required"
      },
      actions: {
        cancel: "Cancel",
        updateTutorial: "Update Tutorial",
        updating: "Updating...",
        view: "View"
      },
      notifications: {
        tutorialUpdated: "Tutorial updated successfully",
        tutorialUpdateFailed: "Failed to update tutorial"
      }
    },
    folders: {
      root: "All Tutorials",
      newFolder: "New Folder",
      createFolder: "Create Folder",
      createTitle: "Create New Folder",
      editTitle: "Rename Folder",
      editFolder: "Edit Folder",
      deleteFolder: "Delete Folder",
      folderName: "Folder Name",
      folderNamePlaceholder: "Enter folder name",
      folderLabel: "Folder",
      emptyFolder: "This folder is empty.",
      creating: "Creating...",
      saving: "Saving...",
      confirmDeleteTitle: "Delete Folder",
      confirmDelete: "Are you sure you want to delete \"{{name}}\" and all its contents?",
      validation: {
        nameRequired: "Folder name is required"
      },
      notifications: {
        created: "Folder created successfully",
        createFailed: "Failed to create folder",
        updated: "Folder renamed successfully",
        updateFailed: "Failed to rename folder"
      }
    }
  },
  labTestBookings: {
    title: "Lab Test Bookings",
    addNew: "Add New Booking",
    createBooking: "Create a Booking",
    viewBooking: "View Booking",
    editBooking: "Edit Booking",
    patientName: "Patient Name",
    testName: "Test Name",
    bookingDate: "Booking Date",
    status: "Status",
    actions: "Actions",
    statusOpen: "Open",
    statusStarted: "Started",
    statusFinished: "Finished",
    statusManuallyCancelled: "Manually Cancelled",
    statusAutoCancelled: "Auto Cancelled",
    statusUpcoming: "Upcoming",
    statusMaybeMissed: "Maybe Missed",
    changeBookingStatus: "Change Booking Status",
    reviewBookingDetails: "Review Booking Details",
    editDetails: "Edit Details",
    startTestNow: "Start the test now?",
    barcodeInput: "Code From Barcode Scanner",
    saving: "Saving...",
    saveBooking: "Save Booking",
    cancel: "Cancel",
    yes: "Yes",
    no: "No",
    price: "Price",
    totalPrice: "Total Price",
    incTax: "inc. tax",
    selectDateTime: "Select Date and Time",
    selectedLabTest: "Selected Lab Test",
    selectedDate: "Selected Date",
    name: "Name",
    email: "Email",
    dateOfBirth: "Date Of Birth",
    age: "Age",
    gender: "Gender",
    postalCode: "Postal Code",
    bookingDateTime: "Booking Date & Time",
    testStarted: "Test started successfully!",
    errorStarting: "Error starting booking: {{message}}",
    errorCreating: "Error creating booking: {{message}}",
    startTest: "Start Test",
    finishTest: "Finish Test",
    reschedule: "Re-schedule",
    confirmCancel: "Are you sure you want to cancel the booking for \"{{name}}\"?",
    starting: "Starting..."
  },
  calendar: {
    title: "Calendar",
    eventAdded: "New Event Added!"
  },
  transactions: {
    title: "Transactions"
  },
  testResults: {
    title: "Test Results",
    subtitle: "Finished lab test results across all pharmacies — one row per test result.",
    searchPlaceholder: "Search by name, email, pharmacy, test, or barcode...",
    rowsPerPage: "Rows per page",
    exportCsv: "Export CSV",
    exportSuccess: "CSV exported successfully",
    exportFailed: "Failed to export CSV",
    showingRows: "Showing {{from}}–{{to}} of {{total}}",
    columns: {
      date: "Date",
      time: "Time",
      pharmacy: "Pharmacy",
      gender: "Gender",
      birthday: "Birthday",
      test: "Test",
      result: "Result",
      resultText: "Result Text",
      color: "Color",
      price: "Price",
    },
  },
};

export default locale; 